module.exports = __webpack_public_path__ + "public/img/exam.3af9d166.png";